import { render, staticRenderFns } from "./RegistrationForLectures.vue?vue&type=template&id=dd940c16&scoped=true&"
import script from "./RegistrationForLectures.vue?vue&type=script&lang=ts&"
export * from "./RegistrationForLectures.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationForLectures.vue?vue&type=style&index=0&id=dd940c16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd940c16",
  null
  
)

export default component.exports